module.exports = __webpack_public_path__ + "static/vmware_8.6ea7335b.jpg";